module.exports = __webpack_public_path__ + "img/Rotunbot.65ae0ff8.png";